import $i18n from 'panda-i18n';
/**
 * @author: yanhoup
 * @description: 顶部菜单
 */
import * as React from 'react';
import styles from './index.module.scss';
import { useSetState } from 'ahooks';
import { useCallback, useEffect } from 'react';
import store from '@/store';
import { useHistory } from 'react-router-dom';
import FpxTab from '@/components/FpxTab';
import { Link } from 'ice';
import { defaultMenuList, otherMenuList } from './topMenu';

interface MenuItem {
  label: string;
  value: string;
  path: string;
}

interface State {
  menuList: MenuItem[];
  activeKey: string;
}

const TopMenu = () => {
  const { pathname } = window.location;

  const history = useHistory();

  const [user, userDispatchers] = store.useModel('user');
  const [permission] = store.useModel('permission');

  const [state, setState] = useSetState<State>({
    menuList: defaultMenuList.map((e: MenuItem) => ({ ...e })),
    activeKey: 'Home',
  });

  useEffect(() => {
    setState({
      menuList: permission.usePermission ? permission.topMenu : defaultMenuList,
    });
  }, [permission, setState, defaultMenuList, permission.usePermission]);

  useEffect(() => {
    if (pathname === '/') {
      setState({
        activeKey: 'Home',
      });
      window.sessionStorage.removeItem('bookParams');
      window.sessionStorage.removeItem('inboundBoardParams');
    }

    const activeMenu = state.menuList.filter((e) => {
      return pathname.startsWith(`/${e.value}/`) || pathname === '/';
    });

    // 根据url定位到具体的大模块
    if (activeMenu.length > 0) {
      userDispatchers.updateMenu({ menu: activeMenu[0].value });
      setState({ activeKey: activeMenu[0].value });
    }
  }, [pathname, setState, state.menuList, userDispatchers]);

  // 顶部菜单点击
  const onHeadMenuClick = useCallback(
    (value) => {
      const item = state.menuList.find((e) => e.value === value);
      userDispatchers.update({ ...user, menu: value });
      history.push(item!.path);
    },
    [state.menuList, userDispatchers, user, history],
  );

  // 上传轨迹到百度埋点
  const uploadTrack = ({ name, link }: any) => {
    const users = JSON.parse(localStorage.getItem('user') || '{}');
    const info = {
      userName: users?.userName || users?.empCode || '',
      link,
    };
    const time = `操作时间: ${new Date()}`;
    // @ts-ignore
    window._hmt.push(['_trackEvent', name, time, JSON.stringify(info)]);
  };

  return (
    <FpxTab
      dataSource={state.menuList}
      className={styles.TopMenu}
      onChange={(value) => onHeadMenuClick(value)}
      activeKey={state.activeKey}
      tabRender={(key, props) => {
        const { path } = state.menuList.find((e) => e.label === props.title)!;
        return (
          <Link
            to={path}
            className={`${styles.Link} next-tabs-tab-inner`}
            key={key}
            onClick={() => uploadTrack({ name: props.title, link: path })}
          >
            {props.title}
          </Link>
        );
      }}
    />
  );
};

export default TopMenu;
